import React from 'react';
import WarningIconSvg from './WarningIconOrange.svg';

const WarningIconOrange = (props) => (
    /* TODO - change to 'webpack inlined' when on react-scripts 2.0 - https://facebook.github.io/create-react-app/docs/adding-images-fonts-and-files#adding-svgs */
    <img src={WarningIconSvg} alt="Warning" {...props} />
);

export default WarningIconOrange;
